import type { MissionListItem } from '../lib/missionCategories'

export type MissionSortOption = 'inProgress' | 'mostProgress' | 'az'

/**
 * 'inProgress' ranks started-but-not-completed items first, not-started
 * next, completed last — matches the "Em andamento" default sort implied
 * by the reference screenshot for this screen.
 */
export function sortMissionItems(
  items: MissionListItem[],
  option: MissionSortOption
): MissionListItem[] {
  const list = [...items]

  return list.sort((a, b) => {
    // Completed items sink to the end regardless of the chosen sort — items
    // still in this list (not the claim banner) with completed: true are
    // already-claimed missions or completed pass objectives, nothing left
    // to do with them. This partition applies before any of the options
    // below, which only order *within* the two groups it creates.
    const doneA = a.completed ? 1 : 0
    const doneB = b.completed ? 1 : 0
    if (doneA !== doneB) return doneA - doneB

    switch (option) {
      case 'inProgress':
        return statusRank(a) - statusRank(b)
      case 'mostProgress':
        return b.progress.percentage - a.progress.percentage
      case 'az':
        return a.title.localeCompare(b.title, 'pt-BR')
    }
  })
}

function statusRank(item: MissionListItem): number {
  return item.progress.current > 0 ? 0 : 1
}
